import { createUseStyles } from 'react-jss'

import { mediumGrey } from '../../../styles/const/colors'

const useStyles = createUseStyles(theme => ({
  header: {
    paddingRight: 30,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10
  },
  headerTitle: {
    fontWeight: 400,
    lineBreak: 'anywhere'
  },
  removeSectionBtn: {
    marginTop: 0,
    color: mediumGrey
  }
}))

export default useStyles
